/** Format gender code to display text */
export function formatGender(code: number): string {
  switch (code) {
    case 1: return '男';
    case 2: return '女';
    default: return '';
  }
}

/** Format date string for display (strip time portion if present) */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr || dateStr.trim() === '' || dateStr === '0001-01-01T00:00:00Z') {
    return '';
  }
  // Handle ISO date strings (e.g. "2020-03-01T00:00:00Z" -> "2020-03-01")
  if (dateStr.includes('T')) {
    return dateStr.substring(0, 10);
  }
  return dateStr;
}
